module.exports = __webpack_public_path__ + "img/about.2fdb7e1a.jpg";